
 <section class="container mt-5">
    <div class="row">
        <div class="col-md-12">
            <h6 id="h6">PLANNING YOUR TRIP TO</h6>
        </div>
        <div class="col-md-6">
            <button type="button" id="btn" class="btn btn-outline-secondary">Europe</button>
            &nbsp;&nbsp;
            <button type="button" id="btn" class="btn btn-outline-secondary">6 - 9 Days</button>
        </div>
        <div class="col-md-6">
            <i class="fa fa-close" id="times"></i>
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgb(255, 201, 51);">
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgba(44, 47, 66, 0.2);">
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgba(44, 47, 66, 0.2);">
        </div>
        <div class="col-md-3">
            <hr style="height:5px;border-width:0;color:gray;
            background-color: rgba(44, 47, 66, 0.2);">
        </div>
        <div class="col-md-12">
            <h4 id="h4">When are you <span id="qwe" class="dotted">
                travelling to</span> Europe</h4>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body"><a href="/customizemonth">
                    <h5 class="card-title">May</h5>
                    <div style="text-align: center;">
                        <button type="button" id="btn1" class="btn btn-warning">
                        <i class="fa fa-flag" id="flag"></i>&nbsp;OUR PICK</button>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;1.°/26°</i>
                    </div></a>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">Jun</h5>
                    <div style="text-align: center;">
                       <p id="par">&nbsp;SECOND BEST</p>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;6.°/30°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">Jul</h5>
                    <div style="text-align: center;">
                        <p id="par">&nbsp;TOO CROWDED</p>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;10.°/34°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">Aug</h5>
                    <div style="text-align: center;">
                        <p id="par">&nbsp;TOO CROWDED</p>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;1.°/26°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">Sep</h5>
                    <div style="text-align: center;">
                        <button type="button" id="btn1" class="btn btn-warning">
                        <i class="fa fa-flag" id="flag"></i>&nbsp;OUR PICK</button>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;1.°/26°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">OCt</h5>
                    <div style="text-align: center;">
                        <button type="button" id="btn1" class="btn btn-warning">
                        <i class="fa fa-flag" id="flag"></i>&nbsp;OUR PICK</button>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;1.°/26°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">Nov</h5>
                    <div style="text-align: center;">
                        <p id="par">&nbsp;OFF SEASON</p>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;1.°/26°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">Dec</h5>
                    <div style="text-align: center;">
                        <p id="par">&nbsp;OFF SEASON</p>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;1.°/26°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2">
            <div class="card" style="border-radius:10px;padding: 25px;">
                <div class="card-body">
                    <h5 class="card-title">Jan</h5>
                    <div style="text-align: center;">
                        <p id="par">&nbsp;OFF SEASON</p>
                    </div>
                    <div style="text-align: center;">
                        <i class="far fa-snowflake" id="snow">&nbsp;1.°/26°</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-4">
            <p id="par1">
                Issue of online vouchers are restricted for departure within the 
                next 9 months. If you are planning for a later date, <span id="span">
                contact us</span>
            </p>
        </div>
        <div class="col-md-1"></div>
    </div>
 </section>